<div class="app-event-stages" *ngIf="deviceInfo !='android' || deviceInfo !='ios' " [ngStyle]="{'color':settingsData?.event_font_main_color}">
    <!-- <div *ngIf= "streamAds" class="w-100"><app-load-ads [streamInfo]="streamInfoData" [blockType] = "'STREAMING_TOP'"></app-load-ads> </div> -->
    <div class="row justify-content-md-center">
        <div class="col-8">
            <div id="myCarousel" class="carousel slide mb-20" data-ride="carousel" data-pause="hover">
                <div class="carousel-inner">
                    <ng-container *ngIf="streamAds && eventHomeAdsTop && eventHomeAdsTop.length > 0 ">
                        <div *ngFor="let a of eventHomeAdsTop; let i=index" class="adv-img1 carousel-item"
                            id="{{a.duration}}" [innerHtml]=a.image [ngClass]="{'active' : i == 0}">
                        </div>
                        <div class="ad-position">
                            <span class="icon-bg "><a class="text-center" [href]="selectedAdData" target="_blank"
                                    class="mr-2 text-white text-decoration-none">Learn more <i
                                        class="fa fa-external-link fs-9 ml-1"></i></a></span>
                        </div>
                    </ng-container>
                </div>
            </div>
            <!-- <div id="myCarousel" class="carousel slide" data-ride="carousel" data-pause="hover">
                <div class="carousel-inner">
                    <ng-container *ngIf="streamAds && streamingPageAdsTop && streamingPageAdsTop.length > 0 ">
                        <div *ngFor="let a of streamingPageAdsTop; let i=index" class="adv-img1 carousel-item"
                            id="{{a.duration}}" [innerHtml]=a.image [ngClass]="{'active' : i == 0}">
                        </div>
                    </ng-container>
                </div>
            </div> -->
        </div>
    </div>

    <h5 class="fs-16">UPCOMING/LIVE</h5>
    <mat-tab-group (selectedTabChange)="onChangeDate($event)" [(selectedIndex)]="selectedTab" mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab *ngFor="let date of datesList; let selected = index;" [label]="date.originalDate">
            <ng-template mat-tab-label class="border-box">
                <div [ngClass]="(selectedDateIndex == selected) ? 'active-date' : 'dates'"
                [ngStyle]="{
                    '--active-date-bg': settingsData?.event_button_bg_primary_color || null,
                    '--active-date-font': settingsData?.event_button_font_primary_color || null
                  }">
                    <div class="right-border notranslate">
                        <div>{{date.start}}</div>
                        <div>{{date.day}}</div>
                    </div>
                </div>
            </ng-template>
            <div class="row pr-0 pl-0 mt-30">
                <div class="col-md-9">
                    <div *ngFor="let subEvent of sortedEventsData; let i = index;let even = even; let odd = odd">
                        <ng-container *ngIf="subEvent?.isMatched">
                            <div class="row no-gutters">
                                <div class="col-12 col-sm-12 col-lg-2 col-md-12 text-right mtext-right p-20 pl-0">
                                    <p class="mfs-11 notranslate">
                                        {{subEvent.stream_info.startTime}}
                                        -
                                        {{subEvent.stream_info.endTime}}
                                    </p>
                                    <p *ngIf="subEvent.stream_info.stream_status == 'progress'"><span
                                            class="live">Live</span></p>
                                    <!-- <p><i class="fa fa-clock-o fs-20 mr-2"></i>30 mins left</p> -->
                                </div>
                                <div class="col-12 col-sm-12 mb-15 col-lg-10 col-md-12"
                                    [ngClass]="{ 'bg-primary-even': even, 'bg-primary-odd': odd}"
                                    [style.--even-bg]="settingsData?.event_bg_primary_color" [style.--even-font]="settingsData?.event_font_primary_color"
                                    [style.--odd-bg]="settingsData?.event_bg_secondary_color" [style.--odd-font]="settingsData?.event_font_secondary_color">
                                    <div class="row no-gutters p-20">
                                        <div class="agenda-block col-12 col-md-9 col-lg-9 pl-0">
                                            <h5 class="fs-16">{{subEvent.stream_info.selected_type ==
                                                'single_session_event' ? subEvent.stream_info.stream_video_title :
                                                subEvent.stream_info.stage}}</h5>
                                            <p class="" 
                                                *ngIf="subEvent.stream_info.stream_video_description"
                                                [innerHTML]="subEvent.stream_info.stream_video_description| nl2br | safe: 'html'">
                                            </p>
                                            <div class="row event-speaker pl-15">
                                                <div class="col-12 col-md-5 col-lg-5 pl-0"
                                                    *ngFor="let guest of subEvent.finalGuestsList">
                                                    <div class="row no-gutters align-items-center">
                                                        <div class="img-fluid text-center">
                                                            <div class="small-roundIcon pt-6 mb-2 text-center"
                                                                *ngIf="(guest?.profile_image =='' || guest?.profile_image ==null) && guest?.shortName"
                                                                [ngStyle]="{'background-color': guest?.userColor }">
                                                                <span
                                                                    class="text-uppercase notranslate">{{guest?.shortName}}</span>
                                                            </div>
                                                            <div class="artist-pic small-roundIcon m-0text-center pointer"
                                                                *ngIf="guest?.profile_image!='' && guest?.profile_image !=null"
                                                                [ngStyle]="{'background-image':' url(' + guest?.profile_image + ')'}">
                                                            </div>
                                                        </div>
                                                        <span class="ml-2">
                                                            <div class="event-speaker-name text-capitalize mb-2">
                                                                {{guest.first_name}}
                                                                {{guest.last_name}}</div>
                                                        </span>


                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-3 col-lg-3 text-right">
                                            <ng-container
                                                *ngIf="streamInfo?.stream_payment_mode !='paid' || ticket_ids.indexOf(subEvent.stream_info.id) != -1 || ticket_ids.indexOf(subEvent.stream_info.parent_streams_id) != -1; else buyTicket">
                                                <ng-container *ngIf="subEvent.stream_info.stream_status == 'completed'">
                                                    <!-- <span class="fs-12 text-uppercase">completed</span><br> -->
                                                    <button mat-flat-button class="flat-primary-button tertiary-bg-button"
                                                        [ngClass]="{'slick-disabled':subEvent.stream_info.conversion_status == 'pending'}"
                                                        [style.background-color]="settingsData?.event_button_bg_primary_color + '!important'"
                                                        [style.color]="settingsData?.event_button_font_primary_color + '!important'"
                                                        (click)="goToRespectiveScreen(subEvent.stream_info)" [disabled]="subEvent.stream_info.
                                                        conversion_status == 'pending' || !isVodPublished" [matTooltip]="!isVodPublished ? 'VOD is not published' : ''">Watch</button>
                                                </ng-container>
                                                <ng-container *ngIf="subEvent.stream_info.stream_status != 'completed'">
                                                    <button *ngIf="!isPastEndTime(subEvent.stream_info)" mat-flat-button class="flat-primary-button tertiary-bg-button"
                                                        (click)="goToRespectiveScreen(subEvent.stream_info)"
                                                        [style.background-color]="settingsData?.event_button_bg_primary_color + '!important'"
                                                        [style.color]="settingsData?.event_button_font_primary_color + '!important'">{{subEvent.stream_info.stream_status
                                                        == 'progress' ? 'Live' : 'Join Now'}}</button>
                                                </ng-container>
                                            </ng-container>
                                            <ng-template #buyTicket>
                                                <ng-container *ngIf="subEvent.stream_info.stream_status == 'completed'">
                                                    <span class="status text-uppercase">completed</span><br>
                                                    <span class="status text-uppercase" *ngIf="!subEvent.isTicket">No
                                                        ticket available</span>
                                                </ng-container><br>
                                                <button *ngIf="ticketsData?.length > 0" mat-flat-button
                                                    class="flat-primary-button mt-2 tertiary-bg-button"
                                                    [style.background-color]="settingsData?.event_button_bg_primary_color + '!important'"
                                                    [style.color]="settingsData?.event_button_font_primary_color + '!important'"
                                                    [ngClass]="{'slick-disabled':!subEvent.isTicket && subEvent.stream_info.stream_status == 'completed'}"
                                                    [disabled]="!subEvent.isTicket && !ticketInfo?.expo && !subEvent.enableTicket"
                                                    (click)="getTicket(subEvent.stream_info)">{{subEvent.stream_info.stream_status
                                                    == 'completed' ? 'Buy VOD' : 'Get Ticket'}}</button>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="col-md-3">
                    <!-- <div *ngIf= "streamAds" class="w-100"><app-load-ads [streamInfo]="streamInfoData" [blockType] = "'STREAMING_RIGHT'"></app-load-ads> </div> -->
                    <div id="RightCarousel" class="carousel slide mt-20" data-ride="carousel" data-pause="hover">
                        <div class="carousel-inner">
                            <ng-container *ngIf="streamAds && eventHomeAdsRight && eventHomeAdsRight.length > 0">
                                <div *ngFor="let a of eventHomeAdsRight; let i=index" class="adv-img2 carousel-item"
                                    id="{{a.duration}}" [innerHtml]=a.image [ngClass]="{'active' : i == 0}">
                                </div>
                                <div class="ad-position">
                                    <span class="icon-bg "><a class="text-center" [href]="selectedAdData"
                                            target="_blank" class="mr-2 text-white text-decoration-none">Learn more <i
                                                class="fa fa-external-link fs-9 ml-1"></i></a></span>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <!-- <div id="myCarousel" class="carousel slide" data-ride="carousel" data-pause="hover">
                        <div class="carousel-inner">
                            <ng-container
                                *ngIf="streamAds && streamingPageAdsRight && streamingPageAdsRight.length > 0">
                                <div *ngFor="let a of streamingPageAdsRight; let i=index" class="adv-img2 carousel-item"
                                    id="{{a.duration}}" [innerHtml]=a.image [ngClass]="{'active' : i == 0}">
                                </div>
                            </ng-container>
                        </div>
                    </div> -->
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>